<template>
  <div class="download-with-table-container">
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm go-to-table"
      v-on:click="scrollToTable" 
      :disabled="loading"
    >
      Таблица
    </button>
    <download-multiselect-button
      :downloadReportType="downloadReportType"
      :urls="urls"
      :disabled="disabled"
      :title="title"
      :chartContainerSelector="chartContainerSelector"
      :chartType="chartType"
    />
  </div>
</template>

<script>
import DownloadMultiselectButton from "./DownloadMultiselectButton.vue";

function waitForElementToDisplay(elementId, time, callback) {
  let attempts = 0;
  const maxAttempts = 50; // Максимум 5 секунд (50 * 100ms)
  
  let interval = setInterval(function() {
    attempts++;
    let element = document.getElementById(elementId);
    
    if(element) {
      clearInterval(interval);
      callback(element);
    } else if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, time);
}

export default {
  name: "DownloadWithTableButton",
  components: {
    DownloadMultiselectButton
  },
  props: {
    downloadReportType: {
      type: String,
      default: "download-sov"
    },
    urls: {
      type: Array,
      default: []
    },
    accordion: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    chartContainerSelector: {
      type: String,
      required: true
    },
    tableTargetId: {
      type: String,
      default: "sov_dynamic_table_header"
    },
    tabTargetId: {
      type: String,
      default: "tab-btn-1"
    },
    chartType: {
      type: String,
      default: "sov"
    }
  },

  data() {
    return {
      loading: false
    };
  },

  methods: {
    scrollToTable() {
      const header = document.getElementById(this.tableTargetId);
      
      if (header) {
        // Сначала скроллим к таблице
        header.scrollIntoView({ behavior: 'smooth' });
        
        // Если аккордеон закрыт, открываем его
        if (this.accordion === false) {
          setTimeout(() => {
            header.click();
          }, 300); // Даем время на скролл
        }
        
        // Ждем появления таба и кликаем по нему
        waitForElementToDisplay(this.tabTargetId, 100, (element) => {
          if (element) {
            // Дополнительная задержка чтобы таблица успела загрузиться
            setTimeout(() => {
              // Пробуем кликнуть по label вместо input
              const label = document.querySelector(`label[for="${this.tabTargetId}"]`);
              if (label) {
                label.click();
              } else {
                element.click();
              }
              
              // Дополнительно: программно устанавливаем checked
              setTimeout(() => {
                // Сначала снимаем checked с всех табов
                const allTabs = document.querySelectorAll('input[name="tab-btn"]');
                allTabs.forEach(tab => tab.checked = false);
                
                // Затем устанавливаем checked на нужный таб
                element.checked = true;
                
                // Переключаем видимость контента
                const allContent = document.querySelectorAll('[id^="content-"]');
                allContent.forEach(content => {
                  content.classList.remove('show');
                });
                
                // Показываем нужный контент
                const contentId = this.tabTargetId === 'tab-btn-1' ? 'content-1' : 
                                 this.tabTargetId === 'tab-btn-2' ? 'content-2' : 
                                 this.tabTargetId === 'tab-btn-3' ? 'content-3' : 'content-1';
                const targetContent = document.getElementById(contentId);
                if (targetContent) {
                  targetContent.classList.add('show');
                }
                
                // Триггерим событие change
                const changeEvent = new Event('change', { bubbles: true });
                element.dispatchEvent(changeEvent);
              }, 100);
            }, 200);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.download-with-table-container {
  display: flex;
  gap: 5px;
}

.go-to-table {
  min-width: 80px;
}
</style>
